import DateFnsUtils from '@date-io/date-fns';
import '@fontsource/roboto';
import { LocalizationProvider } from '@mui/lab';
import { DocumentService, getCustomBrowserAuthClients } from '@price-for-profit/micro-services';
import React from 'react';
import ReactDOM from 'react-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';
import { ErrorFallback } from 'shared/error/error-fallback';
import { ProvideAuth, ProvideQueryClient, ProvideService, ProvideSnackbar, ProvideTheme } from 'shared/providers';
import { registerGoogleAnalytics } from 'startup/register-google-analytics';
import App from './App';
import './index.css';
import { ParameterService, ProductService } from './shared/services';
import { getAppConfig } from './startup/get-app-config';

const run = async () => {
    const baseUrl = process.env.PUBLIC_URL;
    const appConfig = await getAppConfig(baseUrl);
    const { clientApp, httpClient, backendHttpClient } = getCustomBrowserAuthClients({
        clientId: appConfig.appId,
        authDomainHost: appConfig.authDomainHost,
        authorityUrl: appConfig.authorityUrl,
        cacheLocation: 'sessionStorage',
        serviceBaseUrl: appConfig.serviceBaseUrl,
        clientScopes: {
            docs: appConfig.documentAppId,
        },
        backendScopes: {
            belnickbackend: appConfig.serviceId,
        },
    });
    const documentService = new DocumentService(httpClient);
    const productService = new ProductService(backendHttpClient, documentService);
    const parameterService = new ParameterService(backendHttpClient);

    if (appConfig.enableGoogleAnalytics) {
        registerGoogleAnalytics(appConfig.googleTagId);
    }

    const serviceContext = {
        appConfig,
        productService,
        parameterService,
    };

    ReactDOM.render(
        <React.StrictMode>
            <BrowserRouter basename={baseUrl}>
                <ProvideTheme>
                    <ProvideSnackbar>
                        <ErrorBoundary FallbackComponent={ErrorFallback}>
                            <ProvideService context={serviceContext}>
                                <ProvideAuth clientApp={clientApp}>
                                    <ProvideQueryClient>
                                        <LocalizationProvider dateAdapter={DateFnsUtils}>
                                            <App />
                                        </LocalizationProvider>
                                    </ProvideQueryClient>
                                </ProvideAuth>
                            </ProvideService>
                        </ErrorBoundary>
                    </ProvideSnackbar>
                </ProvideTheme>
            </BrowserRouter>
        </React.StrictMode>,
        document.getElementById('root')
    );
};

run().catch(console.error);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
